/* ============================================================
   THEME.JS — Le Reve Shopify Theme
   Sticky header, mobile menu, search overlay, cart drawer, animations
   ============================================================ */

(function () {
  'use strict';

  /* ---- Sticky Header ---- */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 60);
      lastY = y;
    }, { passive: true });
  }

  /* ---- Mobile Menu ---- */
  const hamburger  = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuClose  = document.querySelector('.mobile-menu__close');
  const overlay    = document.querySelector('.overlay');

  function openMobileMenu() {
    mobileMenu?.classList.add('is-open');
    hamburger?.classList.add('is-open');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu?.classList.remove('is-open');
    hamburger?.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', () => {
    mobileMenu?.classList.contains('is-open') ? closeMobileMenu() : openMobileMenu();
  });
  menuClose?.addEventListener('click', closeMobileMenu);
  overlay?.addEventListener('click', () => { closeMobileMenu(); closeCartDrawer(); });

  /* Mobile accordion nav — delegated so it keeps working after the header
     section re-renders in the theme editor (menu is built from nav blocks). */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.mobile-nav__link[data-has-children]');
    if (!link) return;
    e.preventDefault();
    link.closest('.mobile-nav__item')?.classList.toggle('is-open');
  });

  /* ---- Search Overlay ---- */
  const searchOverlay = document.querySelector('.search-overlay');
  const searchOpen    = document.querySelectorAll('[data-search-open]');
  const searchClose   = document.querySelector('.search-overlay__close');
  const searchInput   = document.querySelector('.search-overlay__input');

  function openSearch() {
    searchOverlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 100);
  }
  function closeSearch() {
    searchOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  searchOpen.forEach(btn => btn.addEventListener('click', openSearch));
  searchClose?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeSearch(); closeCartDrawer(); closeMobileMenu(); }
  });

  /* ---- Cart Drawer ---- */
  const cartDrawer  = document.querySelector('.cart-drawer');
  const cartCloseBtn = document.querySelector('.cart-drawer__close');

  function openCartDrawer() {
    cartDrawer?.classList.add('is-open');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    cartDrawer?.classList.remove('is-open');
    if (!mobileMenu?.classList.contains('is-open')) {
      overlay?.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }

  cartCloseBtn?.addEventListener('click', closeCartDrawer);

  document.querySelectorAll('[data-cart-open]').forEach(btn => {
    btn.addEventListener('click', openCartDrawer);
  });

  /* Update cart count badge */
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count > 0 ? count : '';
    });
  }

  /* Fetch and render cart drawer */
  async function fetchAndRenderCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
    } catch (e) {
      console.warn('Cart fetch error', e);
    }
  }

  function renderCartDrawer(cart) {
    const body = document.querySelector('.cart-drawer__body');
    const countEl = document.querySelector('.cart-drawer__count');
    const subtotalEl = document.querySelector('.cart-drawer__subtotal-amount');
    if (!body) return;

    if (countEl) countEl.textContent = `(${cart.item_count})`;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          <p>Your cart is empty</p>
          <a href="/collections/all" class="btn btn--outline-gold btn--sm">Shop Now</a>
        </div>`;
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-line-key="${item.key}">
        <img class="cart-item__image" src="${item.image}" alt="${item.product_title}" loading="lazy">
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          <div class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-item__actions">
            <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
            <button class="cart-item__remove" data-remove-key="${item.key}">Remove</button>
          </div>
        </div>
      </div>
    `).join('');

    /* Remove item handlers */
    body.querySelectorAll('[data-remove-key]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.removeKey;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        fetchAndRenderCart();
      });
    });
  }

  /* Add to cart (called from product form) */
  window.NewParadigm = window.NewParadigm || {};
  window.NewParadigm.addToCart = async function(formData) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await fetchAndRenderCart();
      openCartDrawer();
      showToast('Item added to cart!');
    } catch (e) {
      showToast('Could not add item. Please try again.', true);
    }
  };

  /* ---- Product Form Intercept ---- */
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span class="spinner"></span>';
      }
      await window.NewParadigm.addToCart(new FormData(form));
      if (btn) {
        btn.disabled = false;
        btn.textContent = btn.dataset.label || 'Add to Cart';
      }
    });
  });

  /* ---- Variant Picker ---- */
  document.querySelectorAll('.variant-picker').forEach(picker => {
    picker.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => {
        updateVariantUI(picker.closest('[data-product-section]'));
      });
    });
  });

  function updateVariantUI(section) {
    if (!section) return;
    const form    = section.querySelector('[data-product-form]');
    const radios  = form?.querySelectorAll('input[type="radio"]:checked');
    if (!radios) return;

    const variantId = section.querySelector('[name="id"]');
    const addBtn    = section.querySelector('[data-add-to-cart]');
    const priceEl   = section.querySelector('[data-product-price]');
    const compareEl = section.querySelector('[data-compare-price]');

    const productData = JSON.parse(section.dataset.product || '{}');
    if (!productData.variants) return;

    const selectedOptions = Array.from(radios).map(r => r.value);
    const variant = productData.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (variant) {
      if (variantId) variantId.value = variant.id;
      if (priceEl)   priceEl.textContent   = formatMoney(variant.price);
      if (compareEl) {
        compareEl.textContent = variant.compare_at_price > variant.price
          ? formatMoney(variant.compare_at_price) : '';
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? (addBtn.dataset.label || 'Add to Cart')
          : 'Sold Out';
      }
    }
  }

  /* ---- Quantity Stepper ---- */
  document.querySelectorAll('.qty-stepper').forEach(stepper => {
    const input   = stepper.querySelector('input');
    const minusBtn = stepper.querySelector('[data-minus]');
    const plusBtn  = stepper.querySelector('[data-plus]');
    const min      = parseInt(input?.min || 1);
    const max      = parseInt(input?.max || 999);

    minusBtn?.addEventListener('click', () => {
      const val = parseInt(input.value);
      if (val > min) input.value = val - 1;
    });
    plusBtn?.addEventListener('click', () => {
      const val = parseInt(input.value);
      if (val < max) input.value = val + 1;
    });
  });

  /* ---- Scroll Animations ---- */
  // In the Shopify theme editor there's no natural scrolling and sections
  // re-render on every edit, so just reveal everything immediately there.
  const inDesignMode = window.Shopify && window.Shopify.designMode;

  let fadeObserver = null;
  if ('IntersectionObserver' in window) {
    fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
  }

  function revealFadeEls(root) {
    const scope = root || document;
    const els = scope.querySelectorAll('.fade-in:not(.is-visible)');
    if (inDesignMode || !fadeObserver) {
      els.forEach(el => el.classList.add('is-visible'));
    } else {
      els.forEach(el => fadeObserver.observe(el));
    }
  }

  revealFadeEls();

  // Re-run when the editor adds/edits/re-renders a section so freshly
  // rendered .fade-in elements don't stay stuck at opacity 0.
  document.addEventListener('shopify:section:load', function (e) {
    revealFadeEls(e.target);
  });

  /* ---- Toast Notification ---- */
  let toastTimer;
  function showToast(message, isError = false) {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.borderLeftColor = isError ? '#ff5555' : 'var(--color-gold)';
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }

  /* ---- Utility: Format Money ----
     Formats in the visitor's active currency (set by Shopify Markets when
     enabled), with the currency code. */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const code = window.Shopify?.currency?.active || 'CAD';
    return '$' + amount + ' ' + code;
  }

  /* ---- Init: load cart count on page load ---- */
  fetchAndRenderCart();

})();
